var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.427 10.069h-1.306c-1.285 0-1.686.849-1.686 1.719v2.063h2.871l-.459 3.18h-2.412v7.69a9.811 9.811 0 01-3.235 0v-7.69h-2.627v-3.18H14.2v-2.424c0-2.758 1.545-4.281 3.91-4.281 1.132 0 2.317.215 2.317.215v2.708zm3.498-8.054H8.075a6.06 6.06 0 00-6.06 6.06v15.85a6.06 6.06 0 006.06 6.06h15.85a6.06 6.06 0 006.06-6.06V8.075a6.06 6.06 0 00-6.06-6.06z",
    fill: "#1877F2"
  }))));
}

export default SvgIconSnsFacebook;